import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import swal from 'sweetalert2';
import { ManageJournalDTO } from '../Models/Journal.model';
import { SurgeonDTO, SurgeonSpecialityDTO } from '../Models/Surgeon.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';


@Component({
  selector: 'app-manage-journal',
  templateUrl: './manage-journal.component.html',
  styleUrls: ['./manage-journal.component.scss'],
  providers: [SrubUpService]

})
export class ManageJournalComponent implements OnInit {
  loginUserId: number;
  k = 0;
  nextButtonDisabled: boolean;
  public loading = false;
  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  showReadOnlyDiv: number;
  iValue: number;
  index: boolean;
  edit: boolean;

  surgeonEmailId: string;
  surgeonList: Array<SurgeonDTO>;
  manageJournalList: any = [];
  journalListtemp: any = [];
  journalList: Array<ManageJournalDTO>;
  surgeonProcedures: Array<string>;
  surgeonSpecialityDetails: Array<SurgeonSpecialityDTO>;
  surgeon: SurgeonDTO;

  //related var's of event dto
  journalId: string;
  title: string;   //title serves as Name of journal event.
  surgeonname: string;
  procname: string;
  anaesthetist: string;
  teaminvolved: string;
  notes: string;
  endtime: string;
  className: string;
  start: string;
  end: string;
  startdate: string;      //start sholud be in form of "YYYY-MM-DDTHH:MM:SS"
  starttime: string;

  enddate: string;       //end sholud be in form of "YYYY-MM-DDTHH:MM:SS"
  isImpersonateMode: boolean;
  constructor(private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.surgeonProcedures = new Array<string>();

    this.index = true;

    this.invisible = 0;
    this.editvisi = 0;

    this.showEditingDiv = -1;
    this.showReadOnlyDiv = -1;

  }

  Timezone =
    [
      { value: '00:00:00', viewValue: '00:00' },
      { value: '00:30:00', viewValue: '00:30' },
      { value: '01:00:00', viewValue: '01:00' },
      { value: '01:30:00', viewValue: '01:30' },
      { value: '02:00:00', viewValue: '02:00' },
      { value: '02:30:00', viewValue: '02:30' },
      { value: '03:00:00', viewValue: '03:00' },
      { value: '03:30:00', viewValue: '03:30' },
      { value: '04:00:00', viewValue: '04:00' },
      { value: '04:30:00', viewValue: '04:30' },
      { value: '05:00:00', viewValue: '05:00' },
      { value: '05:30:00', viewValue: '05:30' },
      { value: '06:00:00', viewValue: '06:00' },
      { value: '06:30:00', viewValue: '06:30' },
      { value: '07:00:00', viewValue: '07:00' },
      { value: '07:30:00', viewValue: '07:30' },
      { value: '08:00:00', viewValue: '08:00' },
      { value: '08:30:00', viewValue: '08:30' },
      { value: '09:00:00', viewValue: '09:00' },
      { value: '09:30:00', viewValue: '09:30' },
      { value: '10:00:00', viewValue: '10:00' },
      { value: '10:30:00', viewValue: '10:30' },
      { value: '11:00:00', viewValue: '11:00' },
      { value: '11:30:00', viewValue: '11:30' },
      { value: '12:00:00', viewValue: '12:00' },
      { value: '12:30:00', viewValue: '12:30' },
      { value: '13:00:00', viewValue: '13:00' },
      { value: '13:30:00', viewValue: '13:30' },
      { value: '14:00:00', viewValue: '14:00' },
      { value: '14:30:00', viewValue: '14:30' },
      { value: '15:00:00', viewValue: '15:00' },
      { value: '15:30:00', viewValue: '15:30' },
      { value: '16:00:00', viewValue: '16:00' },
      { value: '16:30:00', viewValue: '16:30' },
      { value: '17:00:00', viewValue: '17:00' },
      { value: '17:30:00', viewValue: '17:30' },
      { value: '18:00:00', viewValue: '18:00' },
      { value: '18:30:00', viewValue: '18:30' },
      { value: '19:00:00', viewValue: '19:00' },
      { value: '19:30:00', viewValue: '19:30' },
      { value: '20:00:00', viewValue: '20:00' },
      { value: '21:00:00', viewValue: '21:00' },
      { value: '21:30:00', viewValue: '21:30' },
      { value: '22:00:00', viewValue: '22:00' },
      { value: '22:30:00', viewValue: '22:30' },
      { value: '23:00:00', viewValue: '23:00' },
      { value: '23:30:00', viewValue: '23:30' }
    ];

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  UserClick(btnCount) {
    this.edit = false;
    this.journalId = "";
    this.title = "";
    this.surgeonname = "";
    this.surgeonEmailId = "";

    this.procname = "";
    this.anaesthetist = "";
    this.teaminvolved = "";
    this.notes = "";
    this.startdate = "";
    this.starttime = "";
    this.start = "";
    this.enddate = "";
    this.endtime = "";
    this.end = "";

    if (btnCount == 1) {
      this.edit = true;
      this.showEditingDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.showEditingDiv = -1;


    }
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  surgeonSelected(surgeonEmailId) {
    this.surgeonProcedures = [];
    this.surgeonEmailId = surgeonEmailId;
    this.surgeon = this.findObjectByKey(this.surgeonList, 'Email', surgeonEmailId);
    if (this.surgeon.Name) {
      this.surgeonname = this.surgeon.Name;
    }
    this.surgeonSpecialityDetails = this.surgeon.SurgeonSpecialities;
    for (let index = 0; index < this.surgeonSpecialityDetails.length; index++) {
      var procNames = this.surgeonSpecialityDetails[index].ProcedureNames;
      procNames.forEach(proc => {
        this.surgeonProcedures.push(proc);
      });
    }
    //this.specialityProcedures = this.procedures.filter(procedure => procedure.SpecialityID === this.specialityId)
  }

  getSurgeonList() {
    this.loading = true;
    let packageTypesFeatures = JSON.parse(
      this.cookieService.get("PackageTypesFeatures")
    );

    const isPackageDowngraded = packageTypesFeatures.IsPackageDowngraded
      ? packageTypesFeatures.IsPackageDowngraded
      : false;

    const surgeon = JSON.parse(localStorage.getItem("Surgeon"));
console.log("surgeon================", surgeon);
    this.scrubUpService.GetSurgeons(this.token, this.loginUserId,0, surgeon.FeatureValue || 0, isPackageDowngraded).subscribe(x => {
      if (x != null && x != undefined) {
        this.surgeonList = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  getJournalList() {
    this.loading = true;
    this.scrubUpService.GetJournals(this.token, this.loginUserId).subscribe(x => {

      if (x['Data'] != null && x['Status'] == true) {
        this.journalListtemp = x['Data']['Journals'];
        for (var i = 0; i < this.journalListtemp.length; i++) {
          for (var j = 0; j < this.journalListtemp[i]['Data'].length; j++) {
            this.manageJournalList.push(this.journalListtemp[i]['Data'][j]);
          }
        }
      }

      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  formatDateTime(dt, time) {
    var date = new Date(dt);
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();

    var mmChars = mm.split('');
    var ddChars = dd.split('');

    return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]) + "T" + time;

  }

  Addjournal() {
    this.start = this.formatDateTime(this.startdate, this.starttime);
    this.end = this.formatDateTime(this.enddate, this.endtime);

    let journal: ManageJournalDTO;
    journal = new ManageJournalDTO();
    journal.JournalId = "";
    journal.Title = this.title;
    journal.SurgeonName = this.surgeonname;
    journal.SurgeonEmail = this.surgeonEmailId;
    journal.JournalProcedure = this.procname;
    journal.Anaesthetist = this.anaesthetist;
    journal.Team = this.teaminvolved;
    journal.Notes = this.notes;
    journal.StartDate = this.startdate;
    journal.StartTime = this.starttime;
    journal.Start = this.start;
    journal.EndDate = this.enddate;
    journal.EndTime = this.endtime;
    journal.End = this.end;

    //manipulate the start and end date as per the calendar requirement

    this.loading = true;
    this.scrubUpService.AddJournal(this.token, journal, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Journal Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(3);
        this.getJournalList();
      }
      else if (x == "exists") {
        swal({
          title: 'Journal with this title already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
      }
      else {

      }
      this.loading = false;
    });
  }

  EditJournal(data: any, index: number) {

    let procedurelistItem: any = [];
    for (var i = 0; i < data['ProcedureList'].length; i++) {
      procedurelistItem.push(data['ProcedureList'][i]['Procedure']);
    }
    this.showReadOnlyDiv = -1;
    this.editvisi = 1;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.procname = procedurelistItem.toString();
      this.anaesthetist = data['Anaesthetist'];
      this.teaminvolved = data['Team'];
      this.notes = data['Notes'];


      this.edit = false;
    }
    else {

      this.procname = procedurelistItem.toString();
      this.anaesthetist = data['Anaesthetist'];
      this.teaminvolved = data['Team'];
      this.notes = data['Notes'];
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
  }

  UpdateJournal() {
    this.start = this.formatDateTime(this.startdate, this.starttime);
    this.end = this.formatDateTime(this.enddate, this.endtime);

    let journal: ManageJournalDTO;
    journal = new ManageJournalDTO();
    journal.JournalId = this.journalId;
    journal.Title = this.title;
    journal.SurgeonName = this.surgeonname;
    journal.SurgeonEmail = this.surgeonEmailId;
    journal.JournalProcedure = this.procname;
    journal.Anaesthetist = this.anaesthetist;
    journal.Team = this.teaminvolved;
    journal.Notes = this.notes;
    journal.StartDate = this.startdate;
    journal.StartTime = this.starttime;
    journal.Start = this.start;
    journal.EndDate = this.enddate;
    journal.EndTime = this.endtime;
    journal.End = this.end;

    this.loading = true;

    this.scrubUpService.UpdateJournal(this.token, journal, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.UserClick(3);
        this.getJournalList();
      }
      else {

      }
      this.loading = false;
    });

  }

  ngOnInit() {
    this.getSurgeonList();
    this.getJournalList();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/manage-journal/manage-journal.component.ts